import * as React from 'react';
import Svg, {
  SvgProps,
  G,
  Rect,
  Path,
  Defs,
  LinearGradient,
  Stop,
  ClipPath,
} from 'react-native-svg';
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const RocketIcon = (props: SvgProps) => (
  <Svg
    width={327}
    height={195}
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Rect
        width={127.881}
        height={126.263}
        x={100.368}
        y={34.369}
        fill="#003A70"
        rx={63.131}
      />
      <Path
        fill="#E5541F"
        d="M163.643 179.586c-10.257-12.1-4.356-22.728-.123-26.53l22.492 6.027c1.765 5.409 1.561 17.564-13.372 22.914-1.149 2.29-5.268 6.382-6.447 6.066-1.179-.316-2.7-5.919-2.55-8.477Z"
      />
      <Path
        fill="#F7C25D"
        d="m167.847 154.216 13.876 3.718c2.128 5.629-6.489 15.407-11.224 14.138-4.735-1.269-7.452-13.929-2.652-17.856Z"
      />
      <Path
        stroke="#B0CBE6"
        strokeLinecap="round"
        strokeWidth={2.428}
        d="m238.92 32.98-6.819 25.45M237.932 48.302l-6.819 25.45"
      />
      <G filter="url(#b)">
        <Path
          fill="#0058AD"
          d="m140.118 101.191 11.462-4.6a1.035 1.035 0 0 1 1.386 1.228c-.032.12-.042.245-.03.368l4.174 42.912a1.62 1.62 0 0 1-1.552 1.775l-17.073.627a6.466 6.466 0 0 0-3.105.925l-18.134 10.931c-1.374.828-2.986-.631-2.299-2.08L139.259 102c.174-.368.481-.657.859-.809ZM232.21 125.867l-7.626-9.716a1.035 1.035 0 0 0-1.814.372c-.033.12-.086.233-.158.334l-25.071 35.076a1.617 1.617 0 0 0 .456 2.312l14.473 9.08a6.46 6.46 0 0 1 2.226 2.354l10.24 18.533c.775 1.404 2.9.947 3.03-.652l4.584-56.563a1.616 1.616 0 0 0-.34-1.13Z"
        />
        <Path
          fill="#fff"
          stroke="#EEF4FA"
          strokeWidth={0.458}
          d="M157.34 75.043c11.102-32.115 31.812-48.918 46.291-55.988 5.76-2.813 12.517-1.003 16.099 4.313 9.003 13.363 18.538 38.27 12.095 71.633-7.532 38.997-27.792 58.963-38.969 65.391-1.534.883-3.297 1.253-5.078 1.19-9.357-.332-17.924-2.625-25.704-6.878-1.497-.818-2.768-1.982-3.623-3.446-6.478-11.089-14.127-38.563-1.111-76.215Z"
        />
        <Path
          fill="#B0CBE6"
          d="M195.417 78.994c12.583 3.372 27.467 1.515 27.659-12.089.209-14.8-4.165-25.258-16.748-28.63-12.583-3.371-21.598 3.498-28.818 16.421-6.635 11.877 5.324 20.927 17.907 24.298Z"
        />
        <Path
          fill="#0058AD"
          d="M195.417 78.994c12.583 3.372 27.467 1.515 27.659-12.089.209-14.8-4.165-25.258-16.748-28.63-12.583-3.371-21.598 3.498-28.818 16.421-6.635 11.877 5.324 20.927 17.907 24.298Z"
        />
        <Path
          fill="url(#c)"
          d="M196.798 74.976c11.253 3.016 23.765 2.57 24.093-8.415.421-14.11-3.344-24.01-14.597-27.025-11.252-3.015-19.774 3.508-26.152 16.107-4.935 9.75 5.403 16.318 16.656 19.333Z"
        />
        <Path
          fill="#0058AD"
          d="M167.645 171.152 186 108.275a1.518 1.518 0 0 1 2.935.786l-15.544 63.631a1.618 1.618 0 0 1-1.991 1.179l-2.62-.702a1.619 1.619 0 0 1-1.135-2.017Z"
        />
      </G>
      <Path
        stroke="#B0CBE6"
        strokeLinecap="round"
        strokeWidth={2.428}
        d="m174.178 39.013-6.819 25.45M168.153 49.867l-6.819 25.45M133.66 102.972l-4.676 17.451M229.118 159.723l-4.676 17.451M135.296 114.32l-4.676 17.451M222.029 168.734l-4.676 17.451"
      />
      <Path
        stroke="#F7C25D"
        strokeLinecap="round"
        strokeWidth={1.619}
        d="m175.127 177.988-2.533 9.452M164.662 170.507l-2.532 9.453"
      />
      <Rect width={40} height={40} x={105.75} y={35.8} fill="#ED364C" rx={20} />
      <Path
        stroke="#F8F8F8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.428}
        d="M117.25 55.8a8.408 8.408 0 0 1 1.755-5.143 8.506 8.506 0 0 1 4.545-3.017 8.554 8.554 0 0 1 5.455.356 8.482 8.482 0 0 1 4.108 3.582m-5.238 0h5.312V46.3m1.063 9.5a8.409 8.409 0 0 1-1.756 5.143 8.5 8.5 0 0 1-4.544 3.017 8.554 8.554 0 0 1-5.455-.356 8.481 8.481 0 0 1-4.108-3.582m5.238 0h-5.313V65.3"
      />
    </G>
    <Defs>
      <LinearGradient
        id="c"
        x1={206.325}
        x2={196.829}
        y1={39.545}
        y2={74.985}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0.502} stopColor="#fff" />
        <Stop offset={1} stopColor="#E6EEF7" />
      </LinearGradient>
      <ClipPath id="a">
        <Path fill="#fff" d="M.006.375h326.988v194.25H.006z" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default RocketIcon;
